<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('wallet.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="almarai-bold active mx-3" aria-current="page">{{$t('wallet.breadcrumb_2')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row" v-if="form == 1">
      <div class="col-12">

        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />

        <mainloader v-if="isLoading" />

        <section v-else>
          <div class="row padding-24">
            <div class="col-12">
              <div class="card wallet-bg">
                <div class="card-body">
                  <div class="row">
                    <div class="col button-center pe-3">
                      <div class="fonttext-14 text-white">{{$t('wallet.title_1')}}</div>
                      <div class="green-2B font-20 almarai-bold" >{{value}} </div>
                    </div>
                    <div class="col-auto button-center text-start">
                      <img src="/assets/images/empty-wallet-2.png" class="width-48" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <h5>{{$t('wallet.title_2')}}</h5>
              <ul class="nav nav-tabs p-0 filter-ul pt-3" id="myTab" role="tablist">
                <li class="nav-item" @click="paymentList()" role="presentation">
                  <button class="nav-link active hover-color filter-style" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">{{$t('wallet.title_3')}}</button>
                </li>
                <li class="nav-item mx-2" @click="paymentList('Users')" role="presentation">
                  <button class="nav-link filter-style hover-color" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">{{$t('wallet.title_4')}}</button>
                </li>
                <li class="nav-item mx-2" @click="paymentList('MaintenanceOrders')" role="presentation">
                  <button class="nav-link filter-style hover-color" id="orders-tab" data-bs-toggle="tab" data-bs-target="#orders-tab-pane" type="button" role="tab" aria-controls="orders-tab-pane" aria-selected="false">{{$t('wallet.title_7')}}</button>
                </li>
                <li class="nav-item mx-2" @click="paymentList('Properties')" role="presentation">
                  <button class="nav-link filter-style hover-color" id="orders-tab" data-bs-toggle="tab" data-bs-target="#FeaturedAd-tab-pane" type="button" role="tab" aria-controls="FeaturedAd-tab-pane" aria-selected="false">{{$t('wallet.FeaturedAd')}}</button>
                </li>
                <li class="nav-item" @click="paymentList('PropReservations')" role="presentation">
                  <button class="nav-link filter-style hover-color" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact-tab-pane" type="button" role="tab" aria-controls="contact-tab-pane" aria-selected="false">{{$t('wallet.title_5')}}</button>
                </li>
                <li class="nav-item mx-2" @click="paymentList('Reservations')" role="presentation">
                  <button class="nav-link filter-style hover-color" id="reservations-tab" data-bs-toggle="tab" data-bs-target="#reservations-tab-pane" type="button" role="tab" aria-controls="reservations-tab-pane" aria-selected="false">{{$t('wallet.title_6')}}</button>
                </li>
                <li class="nav-item mx-2" @click="paymentList('PropertyPayments')" role="presentation">
                  <button class="nav-link filter-style hover-color" id="rentPayment-tab" data-bs-toggle="tab" data-bs-target="#rentPayment-tab-pane" type="button" role="tab" aria-controls="rentPayment-tab-pane" aria-selected="false">{{$t('wallet.rentPayment')}}</button>
                </li>
              </ul>

              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
                  <div class="row justify-content-center pt-5">
                    <div class="col-12 col-md-11 py-2" v-for="(row, index) in rows" :key="index">
                      <div class="row">
                        <div class="row">
                          <div class="col-auto text-center ps-0">
                            <img v-if="row.approved" src="/assets/images/icons/Frame-success.png" class="w-50" alt="">
                            <img v-else src="/assets/images/icons/Frame-false.png" class="w-50" alt="">
                          </div>
                          <div class="col content-center">
                            <div>
                              {{row.description}}
                            </div>
                            <div>
                              {{moment(row.createdAt).format('L')}}
                            </div>
                          </div>
                          <div class="col text-start content-center">
                            <div :class="(row.approved) ? 'green-color' : 'red-color'">
                              {{row.amount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- begin:placehoder image -->
                  <div v-if="!rows.length" class="row justify-content-center">
                    <div class="col text-center">
                      <div class="row">
                        <div class="col">
                          <div><img src="/assets/images/Frame.png" class="w-prcentage-12" alt=""></div>
                          <h4 class="pt-4">{{$t('wallet.title_8')}}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end:placeholder image -->
                </div>

                <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
                  <div class="row pt-5" v-if="!rows.length">
                    <div class="col">
                      <div class="text-center">
                        <img src="/assets/images/profile-icons/Wallet.png" class="width-48" alt="">
                      </div>
                      <div class="almarai-bold font-24 py-2 text-center">{{$t('wallet.title_8')}}</div>
                      <div class="text-center almarai-regular gray-color">
                        <span>{{$t('wallet.title_9')}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tab-pane fade" id="orders-tab-pane" role="tabpanel" aria-labelledby="orders-tab" tabindex="0">
                  <!-- begin:placehoder image -->
                  <div v-if="!rows.length" class="row justify-content-center pt-5">
                    <div class="col text-center">
                      <div class="row">
                        <div class="col">
                          <div><img src="/assets/images/Frame.png" class="w-prcentage-12" alt=""></div>
                          <h4 class="pt-4">{{$t('wallet.title_8')}}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end:placeholder image -->

                  <div class="row pt-5 justify-content-center">
                    <div class="col-12 col-md-11 py-2" v-for="(row, index) in rows" :key="index">
                      <div class="row">
                        <div class="row">
                          <div class="col-auto ps-0">
                            <img src="/assets/images/icons/Frame-success.png" class="w-50" alt="">
                          </div>
                          <div class="col">
                            <div>
                              {{row.description}}
                            </div>
                            <div>
                              {{moment(row.createdAt).format('L')}}
                            </div>
                          </div>
                          <div class="col text-start">
                            <div>
                              {{row.amount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tab-pane fade" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab" tabindex="0">
                  <!-- begin:placehoder image -->
                  <div v-if="!rows.length" class="row justify-content-center pt-5">
                    <div class="col text-center">
                      <div class="row">
                        <div class="col">
                          <div><img src="/assets/images/Frame.png" class="w-prcentage-12" alt=""></div>
                          <h4 class="pt-4">{{$t('wallet.title_8')}}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end:placeholder image -->

                  <div v-else class="row pt-5 justify-content-center">
                    <div class="col-12 col-md-11 py-2" v-for="(row, index) in rows" :key="index">
                      <div class="row">
                        <div class="col-auto ps-0">
                          <img src="/assets/images/icons/Frame-success.png" class="w-50" alt="">
                        </div>
                        <div class="col">
                          <div>
                            {{row.description}}
                          </div>
                          <div>
                            {{moment(row.createdAt).format('L')}}
                          </div>
                        </div>
                        <div class="col text-start">
                          <div>
                            {{row.amount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tab-pane fade" id="reservations-tab-pane" role="tabpanel" aria-labelledby="reservations-tab" tabindex="0">
                  <!-- begin:placehoder image -->
                  <div v-if="!rows.length" class="row justify-content-center pt-5">
                    <div class="col text-center">
                      <div class="row">
                        <div class="col">
                          <div><img src="/assets/images/Frame.png" class="w-prcentage-12" alt=""></div>
                          <h4 class="pt-4">{{$t('wallet.title_8')}}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end:placeholder image -->
                  <div v-else class="row pt-5 justify-content-center">
                    <div class="col-12 col-md-11 py-2" v-for="(row, index) in rows" :key="index">
                      <div class="row">
                        <div class="col-auto ps-0">
                          <img src="/assets/images/icons/Frame-success.png" class="w-50" alt="">
                        </div>
                        <div class="col">
                          <div>
                            {{row.description}}
                          </div>
                          <div>
                            {{moment(row.createdAt).format('L')}}
                          </div>
                        </div>
                        <div class="col text-start">
                          <div>
                            {{row.amount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- begin: FeaturedAd_Tabe -->
                <div class="tab-pane fade" id="FeaturedAd-tab-pane" role="tabpanel" aria-labelledby="FeaturedAd-tab" tabindex="0">
                  <!-- begin:placehoder image -->
                  <div v-if="!rows.length" class="row justify-content-center pt-5">
                    <div class="col text-center">
                      <div class="row">
                        <div class="col">
                          <div><img src="/assets/images/Frame.png" class="w-prcentage-12" alt=""></div>
                          <h4 class="pt-4">{{$t('wallet.title_8')}}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end:placeholder image -->
                  <div v-else class="row pt-5 justify-content-center">
                    <div class="col-12 col-md-11 py-2" v-for="(row, index) in rows" :key="index">
                      <div class="row">
                        <div class="col-auto ps-0">
                          <img src="/assets/images/icons/Frame-success.png" class="w-50" alt="">
                        </div>
                        <div class="col">
                          <div>
                            {{row.description}}
                          </div>
                          <div>
                            {{moment(row.createdAt).format('L')}}
                          </div>
                        </div>
                        <div class="col text-start">
                          <div>
                            {{row.amount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end: FeaturedAd_Tabe -->
                
                <!-- begin: rentPayment_Tabe -->
                <div class="tab-pane fade" id="rentPayment-tab-pane" role="tabpanel" aria-labelledby="rentPayment-tab" tabindex="0">
                  <!-- begin:placehoder image -->
                  <div v-if="!rows.length" class="row justify-content-center pt-5">
                    <div class="col text-center">
                      <div class="row">
                        <div class="col">
                          <div><img src="/assets/images/Frame.png" class="w-prcentage-12" alt=""></div>
                          <h4 class="pt-4">{{$t('wallet.title_8')}}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end:placeholder image -->
                  <div v-else class="row pt-5 justify-content-center">
                    <div class="col-12 col-md-11 py-2" v-for="(row, index) in rows" :key="index">
                      <div class="row">
                        <div class="col-auto ps-0">
                          <img src="/assets/images/icons/Frame-success.png" class="w-50" alt="">
                        </div>
                        <div class="col">
                          <div>
                            {{row.description}}
                          </div>
                          <div>
                            {{moment(row.createdAt).format('L')}}
                          </div>
                        </div>
                        <div class="col text-start">
                          <div>
                            {{row.amount}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end: rentPayment_Tabe -->
              </div>
            </div>
          </div>
          <div class="row py-5 add_Credit">
            <div class="col-11 col-md-5 btn-green" @click="nextStep">
              <div>{{$t('wallet.title_4')}}</div>
            </div>
          </div>
        </section>
      </div>
    </div>


    <div class="row pt-5" v-if="form == 2">
      <div class="col">
        <div class="row pt-3">
          <div class="col">
            <nav>
              <ol class="breadcrumb">
                <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('wallet.breadcrumb_1')}}</router-link></li>
                <i class="fa-solid fa-chevron-left pt-1"></i>
                <li class="breadcrumb-item mouse-hand  mx-3" @click="prevStep" aria-current="page">{{$t('wallet.breadcrumb_2')}}</li>
                <i class="fa-solid fa-chevron-left pt-1"></i>
                <li class="almarai-bold active mx-3" aria-current="page">{{$t('wallet.title_4')}}</li>
              </ol>
            </nav>
          </div>
        </div>
        <errorAlert v-if="hasError" :alertMessage="message" />
        <div class="row justify-content-center pt-5">
          <div class="col-12 col-md-8">
            <div class="card card-color">
              <div class="card-body">
                <form action="">
                  <div class="row pt-3">
                    <div class="col">
                      <div class="walet">
                        <img src="/assets/images/empty-wallet.png" alt=""> 
                        <span class="mx-2">{{$t('wallet.title_10')}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="row justify-content-center py-3">
                    <div class="col">
                      <label class="p-content pb-2">{{$t('wallet.title_11')}}</label>
                      <input type="text" maxlength="10" @input="formatNumber" 
                        class="form-control input_credit" v-model="amount"
                      >
                    </div>
                  </div>

                  <div class="row py-3 justify-content-center">
                    <div class="col-12 col-md-8 btn-green" @click.prevent="addbalanceModal">
                      <div>{{$t('wallet.title_4')}}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Button trigger modal -->
      <button type="button"  id="credit" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
      </button>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="d-flex">
              <button type="button" class="btn-close p-3" data-bs-dismiss="modal" aria-label="Close"></button>
              <h1 class="modal-title fs-5 pt-2" id="exampleModalLabel">{{$t('wallet.title_12')}}</h1>
            </div>
            <div class="modal-body">
              <label for="" class="text-style">{{$t('wallet.title_13')}}</label>
              <div class="row pt-3 justify-content-center">
                <div class="col-11 mouse-hand">
                  <div class="form-check input-style position-R">
                    <label for="radioDefault1">
                      <input class="form-check-input check-radio" type="radio" name="radioDefault" id="radioDefault1">
                      <span class="mx-2">{{$t('wallet.title_14')}}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row pt-5">
                <div class="col mouse-hand" @click.prevent="addbalance()">
                  <div class="btn-green form-control">{{$t('wallet.title_15')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'wallet',
  data(){
    return{
      charge: this.$route.query.charge,
      hasError: false,
      message: "",
      errorNumber: 0,
      isLoading: true,
      form: 1,
      rows: [],
      value:{},
      amount: null,
      userLang: 'ar',
      validateMessage: this.$t('validateMessage'),
    }
  },
  methods:{
    nextStep(){
      this.form += 1;
    },
    prevStep(){
      this.form -= 1;
    },
    paymentList(paymentstype){
      this.hasError = false;
      this.$http.get("/api/payments/paymentsList/?isWallet=1"+'&'+'filter='+paymentstype).then(res => {
        // console.log(res);
        this.value = res.data.balance;
        this.rows = res.data.rows;
        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    moment,
    formatDate(){
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime); 
    },

    addbalance(){
      this.$http.post("/api/users/addBalance",{
        amount: parseInt(this.amount),
      }).then(res => {
        // console.log(res);
        window.location.href = res.data.paymentUrl;
        // if(this.charge){
        //   window.history.back();
        // }
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    addbalanceModal(){
      this.hasError = false;
      if(!this.amount){
        this.message = this.$t('wallet.message');
        this.hasError = true;
        window.scroll(0,0);
        return false;
      }
      document.getElementById('credit').click();
    },

    formatNumber() {
      // امسح أي حروف غير أرقام
      let raw = this.amount.replace(/,/g, "").replace(/\D/g, "");

      // لو فاضي — رجّعه
      if (!raw) {
        this.amount = "";
        return;
      }
      // إضافة الفواصل كل 3 أرقام
      this.amount = Number(raw).toLocaleString("en-US");
    },
  },
  created(){
    this.paymentList();
    this.userLang = localStorage.getItem('lang') ??  'ar';
  }
}
</script>